import React from 'react';
import { DotGlobe } from './DotGlobe';
import { StatTriad } from './StatTriad';
import { ChiefContributorRow } from './ChiefContributorRow';
import { FoundersBand } from './FoundersBand';
import { FeaturedDiplomatCard } from './FeaturedDiplomatCard';
import { PrimaryCta } from './PrimaryCta';
export function BilateralHero() {
  return (
    <section className="hero" aria-labelledby="hero-title">
      <header className="hero__header">
        <h1 id="hero-title" className="hero__title">
          The architecture of{' '}
          <span style={{ color: 'var(--color-accent)' }}>bilateral cooperation</span>
        </h1>
        <p className="hero__subtitle">
          Built bottom up, by the people who live, build, and sustain relationships between
          nations.
        </p>
      </header>

      <div className="hero__stage">
        <div className="hero__globe">
          <DotGlobe />
        </div>
        <aside className="hero__featured">
          <FeaturedDiplomatCard />
        </aside>
      </div>

      <div className="hero__stats">
        <StatTriad />
      </div>

      <div id="chief-row" className="hero__chief-row">
        <h2 className="hero__eyebrow" style={{ textAlign: 'center', margin: '0 0 var(--space-md)' }}>
          Contributors
        </h2>
        <ChiefContributorRow />
      </div>

      <FoundersBand />

      <PrimaryCta />
    </section>
  );
}
